import { useMutation } from '@tanstack/react-query';

import { authApi } from '../api/auth-api';

/** Always 202 whether or not the address exists; only 429 (5/min) is a visible failure. */
export function useForgotPassword() {
  return useMutation({ mutationFn: authApi.forgotPassword, meta: { silentError: true } });
}
